/* tslint:disable */
/* eslint-disable */
/**
 * API
 * This document specifies the application programming interface (API) for Hellewi.  # URL format  `https://api.<domain>/<version>/<tenant>/<language>/<endpoint>`  e.g. `https://api.opistopalvelut.fi/v1/demo/fi/courses`  - protocol: `https` ssl must be used. - domain: `opistopalvelut.fi` domain should be the same as with tenant\'s   admin and registration domain (i.e. not necessarily opistopalvelut.fi). - version: `v1` marks the API version, only v1 is supported. - tenant: `demo` is the tenant name, should be the same as with   admin/registration url - language: `fi` is language selection, options fi/en/sv are supported - endpoint: `courses` api endpoint  Tenant must be given also inside [JWT](#section/Authentication/JWT), and it must match the tenant/domain in URL.  ## Multi-tenant request  `https://api.linnunrata.fi/<version>/<language>/<endpoint>`  e.g. `https://api.linnunrata.fi/v1/fi/courses`  This will search for courses from all the tenants that the used api key can access. All endpoints do not support multi-tenancy, those that do are listed under tag [MultiTenant](#tag/MultiTenant).  # Testing API  - url: `https://api.opistopalvelut.fi/v1/demo/fi/` - api key: `demo` - secret: `salasana`  Testing API can access only the demo tenant (\"database\" or \"client\"). You can however access multiple tenants with the same API key depending on your license.  # Search  Search query API follows [GitHub Search](https://developer.github.com/v3/search) closely.  Search string is in format `?q=SEARCH_TERM_1+SEARCH_TERM_N+FILTER_1+FILTER_N`, e.g. search terms and filters combined with `+` signs or url-encoded spaces `%20`.  Search terms are keywords to be searched. Disallowed characters are: `: + \" \'`. Results are sorted by default based on matching: best matching entries first.  ### Filters  Filters are in format `field:value`. In this simplest case, the field must be equal to the given value.  If there are multiple filters defined, results must match *all* different filters. If there are multiple filter values for the same field, results must match *one* of those. For example: `?q=department:3+subject:1+subject:2` means that all courses with department 3 and subject 1 or 2.  ### Filter operators  Supported operators in filters: - `:` equality, for example: `subject:1` - `:!` not, for example: `department:!2` - `:<` less than, for example: `distancesoft:<10km` - `:<=` less than or equal, for example: `ends:<=2020-02-01` - `:>` greater than, for example: `begins:>2019-01-01` - `:>=` greater than or equal, for example: `begins:>=2019-01-01`  ## Pagination  Pagination is handled with response headers.  Unfortunately these are not included in swagger.json due to technical restrictions in the spec generation.  ### link  `link` follows [RFC5988](https://tools.ietf.org/html/rfc5988#section-5) and [GitHub pagination](https://developer.github.com/v3/guides/traversing-with-pagination/): there are at most four links:   - `rel=\"first\"` gives the first page of results with current filters   - `rel=\"prev\"` previous page   - `rel=\"next\"` next page   - `rel=\"last\"` last page  For example (linefeeds added):      GET https://api.opistopalvelut.fi/v1/demo/fi/courses?page=5&limit=2      link: <https://api.opistopalvelut.fi/v1/demo/fi/courses?page=1&limit=2>; rel=\"first\",           <https://api.opistopalvelut.fi/v1/demo/fi/courses?page=4&limit=2>; rel=\"prev\",           <https://api.opistopalvelut.fi/v1/demo/fi/courses?page=6&limit=2>; rel=\"next\",           <https://api.opistopalvelut.fi/v1/demo/fi/courses?page=14&limit=2>; rel=\"last\"  If the query is for the first page, first and prev are omitted. Similarly, if the query is for the last page, last and next are omitted.  If there are no results, all links are omitted.  The link-header should be used for creating pagination functionality.  ### x-total-count  `x-total-count` is the total number of items in result set.  For example:      GET https://api.opistopalvelut.fi/v1/demo/fi/courses?page=5&limit=2      x-total-count: 29  The maximum number here is 10000. If you are expecting a bigger number, or are interested only in the total course count and not the results itself, you should be using [GetCourseCount](#operation/GetCourseCount).  ## Course search  Field explanations by name can be found from [ListCourses](#operation/ListCourses) response schema.  ### Search term  Search term matches text in following course fields with relative weights in parenthesis:  - name (10) - code (7) - teacher (5) - subject (4) - location (3) - category (2) - description (1)  Search terms can have multiple words combined with double quotation marks `\"`.  For example:  `?q=jooga` search term \"jooga\" (probably in course name)  `?q=830107+\"dynaaminen jooga\"` search terms \"830107\" and \"dynaaminen jooga\"  ### Equality filters by id  - category - classification - department - educationsector - language - levelofstudy - location - moduleparent (also null works) - period - subject - tag - tenant - term - weekday  Category can be queried with a path \"department/category\" and subject with \"department/category/subject\" or \"category/subject\".  Tenant makes sense only in the context of multi-tenant requests.  For example:  `?q=department:3+subject:1+subject:2` all courses with department 3 *and* subject 1 *or* 2  `q=weekday:1` courses that have lessons on Monday  `q=moduleparent:18` module child courses that have parent course 18  `q=moduleparent:null` all courses that are not module child courses  ### Date filters  - begins (date-only, YYYY-MM-DD) - ends (date-only, YYYY-MM-DD) - registrationbegins (date-time, YYYY-MM-DDTHH:MM:SSZ) - registrationendssoft (date-time, YYYY-MM-DDTHH:MM:SSZ) - registrationendshard (date-time, YYYY-MM-DDTHH:MM:SSZ)  For example:  `?q=begins:>=2019-01-01`: courses that begin after or on 1.1.2019  ### Distance filters  - distancefrom (origin coordinates: \\<latitude\\>,\\<longitude\\>) - distancehard (distance: \\<number\\>km or \\<number\\>m), if course\'s   location is farther, course will not be included in results - distancesoft (distance: \\<number\\>km or \\<number\\>m), will return all   courses ordered by distance, courses farther than this distance will   be ranked considerably lower (but if only this filter is used, value   can be anything)  distancefrom must be given if either filter is used. Only less than operator `:<` is supported for distancehard and distancesoft.  For example:  `?q=distancefrom:60.169,24.944+distancehard:<50km+distancesoft:<10km`: courses that are closer than 50km from 60.169,24.944, ordered by proximity  ### Other filters  - registrationopen (boolean, only true supported)  registration is currently open. See rules in [Registration](#section/Registration).  For example:  `?q=registrationopen:true`: courses where registration is open currently  ### Distance learning (etäopetus)  Distance learning courses have a special location `distancelearning`:  `?q=location:distancelearning`: only distance learning courses  `?q=location:!distancelearning`: only non-distance learning (lähiopetus) courses  ### Additional examples  `?q=jooga+category:2`: search term \"jooga\" in category 2 courses  `?q=department:3+subject:1+subject:2` all courses with department 3 *and* subject 1 *or* 2  `?q=jooga+begins:>=2019-01-01` search term \"jooga\" in courses that begin after or on 1.1.2019  # Registration  Deciding whether you can register to a course follows these rules that are compared in order (i.e. when a rule matches, the rest are not evaluated): 1. current time < course.registrationbegins: **registration IS NOT open**<br>    Registration is not yet started. 2. course.ends < current time: **registration IS NOT open**<br>    Course has already ended. If course ending time is not defined, this    step is skipped. 3. current time < course.registrationendshard: **registration IS open**<br>    Registration is not yet ended. 4. otherwise: **registration IS NOT open**  Admin interface has only one time for registration ending. It also has a global setting for making that ending time either a soft or hard deadline. API registrationendshard takes this global setting into account (it will be null if registrationends is a soft deadline). Also, if registration beginning or ending time is undefined in admin interface, they will be null in API (i.e. registrationbegins null => registration not open, registrationends null => registration is open).  ## Registration to lessons  Some courses can have registration to single or multiple lessons in addition to registration to the whole course. Registering to lessons can be enabled from admin interface, and is possible if registration to the course is open, and if there is available places in that lesson.  Selecting a price means that registration is for the whole course, where selecting lessons means that registration is only for the specified lessons. Both options are not always present, they follow these rules:  1. If course has registration to lessons (\"registration practice\" /    \"ilmoittautumistapa: ilmoittautuminen kerroille\") and lessons defined,    lessons can be selected. 2. If registration to lessons is restricted (\"lesson registration limit\" /    \"kuinka monelle seuraavalle kerralle voi ilmoittautua\"), prices cannot    be selected. 3. If registration to lessons doesn\'t cost anything (\"single lesson fee\" /    \"kertamaksu\" 0,00 e) and all course prices are also zero, prices (and    lessons) can be selected. 4. If registration to lessons cost something and all course prices are    *not* zero, prices (and lessons) can be selected. 5. If course doesn\'t have any prices and registration to lessons is free,    leaving lessons empty is also allowed, which means that the registration    is for the whole course.  Note that even when prices and lessons are both selectable, user cannot select both at the same time.  Registration to lessons\' spare places is not possible.  ## Selecting installments  Prices can have one or more installment groups that can be selected as payment option. Installment options can also expire so that for example course has separate installments for fall and spring period, and fall installment is only valid until the change of period.  Course can have prices with installments and prices without installments at the same time. If a course price has installments, selecting one is required.  ## How price is calculated  1. Lessons selected: price will be the price of combined lessons 2. Spare place: price for a spare place course is always zero 3. Installments selected: price that can or has to be paid after registration    will be the price of the first installment, other installments will be    billed later 4. Otherwise: price will be the selected price  # Rate limit  Requests to API are rate limited to 100 requests per 10 seconds. When this rate limit is exceeded, API will respond with HTTP status code 429 too many requests.  # JWT authentication  Required fields for header are: - `typ` must always be \'JWT\' - `alg` JWT signing algorithm, supported algorithms are: \'HS256\',   \'HS384\' and \'HS512\' - `kid` API key (*not* secret), \'demo\' can be used for testing with   demo data  Required fields for payload are: - `sub` subject, must be \'hellewi-api-v1\' for this API - `iat` issued at (unix timestamp) - `exp` expiration time (unix timestamp). Maximum expiration time is   one week in the future. When using key id \'demo\', this is not   enforced. - `tenant` tenant identifier, this is in format `<tenant>.<domain>`,   e.g. for opistopalvelut.fi/demo tenant is demo.opistopalvelut.fi - `jti` JWT id, unique identifier, used for identifying sessions. This   must be a random string.  More information about JWTs and an excellent tool for generating JWT tokens for testing can be found at [jwt.io](https://jwt.io).  JWT formatting can be tested against [JWT status endpoint](#operation/GetStatusJwt)  For simple authentication testing, here is a ready-made JWT:  Header: ```json {   \"alg\": \"HS256\",   \"typ\": \"JWT\",   \"kid\": \"demo\" } ```  Payload: ```json {   \"iat\": 1516239022,   \"exp\": 2524608000,   \"sub\": \"hellewi-api-v1\",   \"tenant\": \"demo.opistopalvelut.fi\",   \"jti\": \"ahtu0aiWo4aMooshie9waethae7cuaj0ua2uichieshaevee3j\" } ```  Secret: `salasana`  Encoded (linefeeds added): ```markup eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6ImRlbW8ifQ.eyJpYXQiOjE1 MTYyMzkwMjIsInN1YiI6ImhlbGxld2ktYXBpLXYxIiwidGVuYW50IjoiZGVtby5vcGl zdG9wYWx2ZWx1dC5maSIsImp0aSI6ImFodHUwYWlXbzRhTW9vc2hpZTl3YWV0aGFlN2 N1YWowdWEydWljaGllc2hhZXZlZTNqIiwiZXhwIjoyNTI0NjA4MDAwfQ.BhzoUPL7Vm LCsrtTaZ2yyPIljYNZEiUyoayqRYchm3g ```  Shell command: ```bash curl -v -H \"Authorization: Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXV CIsImtpZCI6ImRlbW8ifQ.eyJpYXQiOjE1MTYyMzkwMjIsInN1YiI6ImhlbGxld2ktY XBpLXYxIiwidGVuYW50IjoiZGVtby5vcGlzdG9wYWx2ZWx1dC5maSIsImp0aSI6ImFo dHUwYWlXbzRhTW9vc2hpZTl3YWV0aGFlN2N1YWowdWEydWljaGllc2hhZXZlZTNqIiw iZXhwIjoyNTI0NjA4MDAwfQ.BhzoUPL7VmLCsrtTaZ2yyPIljYNZEiUyoayqRYchm3g\" https://api.opistopalvelut.fi/v1/demo/fi/status/jwt ```  # HMAC request signing  JWT authentication is used on server to server communication, but sometimes there is a need for authenticating requests that originate from user\'s browser, such as viewing previously done registrations.  Note that the signed request links must be generated in a backend service as the signing uses api secret which must not be given to users.  Fields used for HMAC calculation, example from [GetStatusHmac](#operation/GetStatusHmac):   - all request parameters *except* `hmac`:     - `reqid`: random UUIDv4 string, e.g.       \'9b1deb4d-3b7d-4bad-9bdd-2b0d7b3dcb6d\'     - `expiry`: expiration time in ISO8601 format, e.g.       \'2023-06-15T06:00:00Z\'     - there probably are also other parameters, depending on the endpoint   - two additional parameters that are *not* in the actual request:     - `scope`: endpoint HMAC scope, this is show in each endpoint\'s       authorizations-section and start with \'hmac-\',       e.g. \'hmac-status-required\'     - `tenant`: same tenant string as is used in JWT authentication,       e.g. \'demo.opistopalvelut.fi\'  All listed parameters are then ordered alphabetically and url-encoded as if they were normal query parameters (linefeed added):  ```markup expiry=2023-06-15T06%3A00%3A00Z&reqid=9b1deb4d-3b7d-4bad-9bdd-2b0d7b3dcb6d& scope=hmac-status-required&tenant=demo.opistopalvelut.fi ```  Then HMAC digest is calculated with SHA-256 using api secret. Above with secret `salasana`:  ```markup 88290d424fa7bc11afc22140346ba3f3fa0552bff121fb6fb63c60deec7b796a ```  This is used as the request `hmac` parameter value.  So after all the request is (linefeeds added): ```markup https://api.opistopalvelut.fi/v1/demo/fi/status/hmac ?expiry=2023-06-15T06%3A00%3A00Z &reqid=9b1deb4d-3b7d-4bad-9bdd-2b0d7b3dcb6d &hmac=88290d424fa7bc11afc22140346ba3f3fa0552bff121fb6fb63c60deec7b796a ```  HMAC can be tested against [HMAC status endpoint](#operation/GetStatusHmac). JWT must be used there as well:  ```bash curl -v -H \"Authorization: Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXV CIsImtpZCI6ImRlbW8ifQ.eyJpYXQiOjE1MTYyMzkwMjIsInN1YiI6ImhlbGxld2ktY XBpLXYxIiwidGVuYW50IjoiZGVtby5vcGlzdG9wYWx2ZWx1dC5maSIsImp0aSI6ImFo dHUwYWlXbzRhTW9vc2hpZTl3YWV0aGFlN2N1YWowdWEydWljaGllc2hhZXZlZTNqIiw iZXhwIjoyNTI0NjA4MDAwfQ.BhzoUPL7VmLCsrtTaZ2yyPIljYNZEiUyoayqRYchm3g\" \"https://api.opistopalvelut.fi/v1/demo/fi/status/hmac ?expiry=2023-06-15T06%3A00%3A00Z &reqid=9b1deb4d-3b7d-4bad-9bdd-2b0d7b3dcb6d &hmac=88290d424fa7bc11afc22140346ba3f3fa0552bff121fb6fb63c60deec7b796a\" ```  ## Node.js implementation  Uses `date-fns` and `uuid` external libraries, and node.js `crypto`.  ```javascript import { createHmac } from \'crypto\'; import { addYears } from \'date-fns\'; import { v4 as uuidv4 } from \'uuid\';  const HMAC_ALGORITHM = \'sha256\'; const API_SECRET = \'salasana\'; // use proper secret handling  const queryParamsWithoutHmac = {   // use shorter expiration   expiry: addYears(new Date(), 2).toISOString(),   reqid: uuidv4() };  const hmacCalculationParams = {   ...queryParamsWithoutHmac,   scope: \'hmac-status-required\',   tenant: \'demo.opistopalvelut.fi\' };  const hmacCalculationURLSearchParams = new URLSearchParams(   hmacCalculationParams ); hmacCalculationURLSearchParams.sort();  const hmac = createHmac(HMAC_ALGORITHM, API_SECRET)   .update(hmacCalculationURLSearchParams.toString())   .digest(\'hex\');  const queryParams = {   ...queryParamsWithoutHmac,   hmac };  const urlSearchParams = new URLSearchParams(queryParams);  console.log(queryParams); console.log(urlSearchParams.toString()); ```  Prints out: ```markup {   reqid: \'09d1eb20-1b84-4af6-935b-6de0db0b3e75\',   expiry: \'2024-01-05T10:32:50.646Z\',   hmac: \'27d7d2d4136f9e4962a6058296864f15985f81086d145ae687075ce60510c987\' } reqid=09d1eb20-1b84-4af6-935b-6de0db0b3e75&expiry=2024-01-05T10%3A32%3A50.646Z&hmac=27d7d2d4136f9e4962a6058296864f15985f81086d145ae687075ce60510c987 ``` 
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: perttu.tikka@hellewi.fi
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const BASE_PATH = "https://api.opistopalvelut.fi/v1/demo/fi".replace(/\/+$/, "");

export interface ConfigurationParameters {
    basePath?: string; // override base path
    fetchApi?: FetchAPI; // override for fetch implementation
    middleware?: Middleware[]; // middleware to apply before/after fetch requests
    queryParamsStringify?: (params: HTTPQuery) => string; // stringify function for query strings
    username?: string; // parameter for basic security
    password?: string; // parameter for basic security
    apiKey?: string | Promise<string> | ((name: string) => string | Promise<string>); // parameter for apiKey security
    accessToken?: string | Promise<string> | ((name?: string, scopes?: string[]) => string | Promise<string>); // parameter for oauth2 security
    headers?: HTTPHeaders; //header params we want to use on every request
    credentials?: RequestCredentials; //value for the credentials param we want to use on each request
}

export class Configuration {
    constructor(private configuration: ConfigurationParameters = {}) {}

    set config(configuration: Configuration) {
        this.configuration = configuration;
    }

    get basePath(): string {
        return this.configuration.basePath != null ? this.configuration.basePath : BASE_PATH;
    }

    get fetchApi(): FetchAPI | undefined {
        return this.configuration.fetchApi;
    }

    get middleware(): Middleware[] {
        return this.configuration.middleware || [];
    }

    get queryParamsStringify(): (params: HTTPQuery) => string {
        return this.configuration.queryParamsStringify || querystring;
    }

    get username(): string | undefined {
        return this.configuration.username;
    }

    get password(): string | undefined {
        return this.configuration.password;
    }

    get apiKey(): ((name: string) => string | Promise<string>) | undefined {
        const apiKey = this.configuration.apiKey;
        if (apiKey) {
            return typeof apiKey === 'function' ? apiKey : () => apiKey;
        }
        return undefined;
    }

    get accessToken(): ((name?: string, scopes?: string[]) => string | Promise<string>) | undefined {
        const accessToken = this.configuration.accessToken;
        if (accessToken) {
            return typeof accessToken === 'function' ? accessToken : async () => accessToken;
        }
        return undefined;
    }

    get headers(): HTTPHeaders | undefined {
        return this.configuration.headers;
    }

    get credentials(): RequestCredentials | undefined {
        return this.configuration.credentials;
    }
}

export const DefaultConfig = new Configuration();

/**
 * This is the base class for all generated API classes.
 */
export class BaseAPI {

    private static readonly jsonRegex = new RegExp('^(:?application\/json|[^;/ \t]+\/[^;/ \t]+[+]json)[ \t]*(:?;.*)?$', 'i');
    private middleware: Middleware[];

    constructor(protected configuration = DefaultConfig) {
        this.middleware = configuration.middleware;
    }

    withMiddleware<T extends BaseAPI>(this: T, ...middlewares: Middleware[]) {
        const next = this.clone<T>();
        next.middleware = next.middleware.concat(...middlewares);
        return next;
    }

    withPreMiddleware<T extends BaseAPI>(this: T, ...preMiddlewares: Array<Middleware['pre']>) {
        const middlewares = preMiddlewares.map((pre) => ({ pre }));
        return this.withMiddleware<T>(...middlewares);
    }

    withPostMiddleware<T extends BaseAPI>(this: T, ...postMiddlewares: Array<Middleware['post']>) {
        const middlewares = postMiddlewares.map((post) => ({ post }));
        return this.withMiddleware<T>(...middlewares);
    }

    /**
     * Check if the given MIME is a JSON MIME.
     * JSON MIME examples:
     *   application/json
     *   application/json; charset=UTF8
     *   APPLICATION/JSON
     *   application/vnd.company+json
     * @param mime - MIME (Multipurpose Internet Mail Extensions)
     * @return True if the given MIME is JSON, false otherwise.
     */
    protected isJsonMime(mime: string | null | undefined): boolean {
        if (!mime) {
            return false;
        }
        return BaseAPI.jsonRegex.test(mime);
    }

    protected async request(context: RequestOpts, initOverrides?: RequestInit | InitOverrideFunction): Promise<Response> {
        const { url, init } = await this.createFetchParams(context, initOverrides);
        const response = await this.fetchApi(url, init);
        if (response && (response.status >= 200 && response.status < 300)) {
            return response;
        }
        throw new ResponseError(response, 'Response returned an error code');
    }

    private async createFetchParams(context: RequestOpts, initOverrides?: RequestInit | InitOverrideFunction) {
        let url = this.configuration.basePath + context.path;
        if (context.query !== undefined && Object.keys(context.query).length !== 0) {
            // only add the querystring to the URL if there are query parameters.
            // this is done to avoid urls ending with a "?" character which buggy webservers
            // do not handle correctly sometimes.
            url += '?' + this.configuration.queryParamsStringify(context.query);
        }

        const headers = Object.assign({}, this.configuration.headers, context.headers);
        Object.keys(headers).forEach(key => headers[key] === undefined ? delete headers[key] : {});

        const initOverrideFn =
            typeof initOverrides === "function"
                ? initOverrides
                : async () => initOverrides;

        const initParams = {
            method: context.method,
            headers,
            body: context.body,
            credentials: this.configuration.credentials,
        };

        const overriddenInit: RequestInit = {
            ...initParams,
            ...(await initOverrideFn({
                init: initParams,
                context,
            }))
        };

        let body: any;
        if (isFormData(overriddenInit.body)
            || (overriddenInit.body instanceof URLSearchParams)
            || isBlob(overriddenInit.body)) {
          body = overriddenInit.body;
        } else if (this.isJsonMime(headers['Content-Type'])) {
          body = JSON.stringify(overriddenInit.body);
        } else {
          body = overriddenInit.body;
        }

        const init: RequestInit = {
            ...overriddenInit,
            body
        };

        return { url, init };
    }

    private fetchApi = async (url: string, init: RequestInit) => {
        let fetchParams = { url, init };
        for (const middleware of this.middleware) {
            if (middleware.pre) {
                fetchParams = await middleware.pre({
                    fetch: this.fetchApi,
                    ...fetchParams,
                }) || fetchParams;
            }
        }
        let response: Response | undefined = undefined;
        try {
            response = await (this.configuration.fetchApi || fetch)(fetchParams.url, fetchParams.init);
        } catch (e) {
            for (const middleware of this.middleware) {
                if (middleware.onError) {
                    response = await middleware.onError({
                        fetch: this.fetchApi,
                        url: fetchParams.url,
                        init: fetchParams.init,
                        error: e,
                        response: response ? response.clone() : undefined,
                    }) || response;
                }
            }
            if (response === undefined) {
              if (e instanceof Error) {
                throw new FetchError(e, 'The request failed and the interceptors did not return an alternative response');
              } else {
                throw e;
              }
            }
        }
        for (const middleware of this.middleware) {
            if (middleware.post) {
                response = await middleware.post({
                    fetch: this.fetchApi,
                    url: fetchParams.url,
                    init: fetchParams.init,
                    response: response.clone(),
                }) || response;
            }
        }
        return response;
    }

    /**
     * Create a shallow clone of `this` by constructing a new instance
     * and then shallow cloning data members.
     */
    private clone<T extends BaseAPI>(this: T): T {
        const constructor = this.constructor as any;
        const next = new constructor(this.configuration);
        next.middleware = this.middleware.slice();
        return next;
    }
};

function isBlob(value: any): value is Blob {
    return typeof Blob !== 'undefined' && value instanceof Blob;
}

function isFormData(value: any): value is FormData {
    return typeof FormData !== "undefined" && value instanceof FormData;
}

export class ResponseError extends Error {
    override name: "ResponseError" = "ResponseError";
    constructor(public response: Response, msg?: string) {
        super(msg);
    }
}

export class FetchError extends Error {
    override name: "FetchError" = "FetchError";
    constructor(public cause: Error, msg?: string) {
        super(msg);
    }
}

export class RequiredError extends Error {
    override name: "RequiredError" = "RequiredError";
    constructor(public field: string, msg?: string) {
        super(msg);
    }
}

export const COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|",
};

export type FetchAPI = WindowOrWorkerGlobalScope['fetch'];

export type Json = any;
export type HTTPMethod = 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE' | 'OPTIONS' | 'HEAD';
export type HTTPHeaders = { [key: string]: string };
export type HTTPQuery = { [key: string]: string | number | null | boolean | Array<string | number | null | boolean> | Set<string | number | null | boolean> | HTTPQuery };
export type HTTPBody = Json | FormData | URLSearchParams;
export type HTTPRequestInit = { headers?: HTTPHeaders; method: HTTPMethod; credentials?: RequestCredentials; body?: HTTPBody };
export type ModelPropertyNaming = 'camelCase' | 'snake_case' | 'PascalCase' | 'original';

export type InitOverrideFunction = (requestContext: { init: HTTPRequestInit, context: RequestOpts }) => Promise<RequestInit>

export interface FetchParams {
    url: string;
    init: RequestInit;
}

export interface RequestOpts {
    path: string;
    method: HTTPMethod;
    headers: HTTPHeaders;
    query?: HTTPQuery;
    body?: HTTPBody;
}

export function querystring(params: HTTPQuery, prefix: string = ''): string {
    return Object.keys(params)
        .map(key => querystringSingleKey(key, params[key], prefix))
        .filter(part => part.length > 0)
        .join('&');
}

function querystringSingleKey(key: string, value: string | number | null | undefined | boolean | Array<string | number | null | boolean> | Set<string | number | null | boolean> | HTTPQuery, keyPrefix: string = ''): string {
    const fullKey = keyPrefix + (keyPrefix.length ? `[${key}]` : key);
    if (value instanceof Array) {
        const multiValue = value.map(singleValue => encodeURIComponent(String(singleValue)))
            .join(`&${encodeURIComponent(fullKey)}=`);
        return `${encodeURIComponent(fullKey)}=${multiValue}`;
    }
    if (value instanceof Set) {
        const valueAsArray = Array.from(value);
        return querystringSingleKey(key, valueAsArray, keyPrefix);
    }
    if (value instanceof Date) {
        return `${encodeURIComponent(fullKey)}=${encodeURIComponent(value.toISOString())}`;
    }
    if (value instanceof Object) {
        return querystring(value as HTTPQuery, fullKey);
    }
    return `${encodeURIComponent(fullKey)}=${encodeURIComponent(String(value))}`;
}

export function mapValues(data: any, fn: (item: any) => any) {
  return Object.keys(data).reduce(
    (acc, key) => ({ ...acc, [key]: fn(data[key]) }),
    {}
  );
}

export function canConsumeForm(consumes: Consume[]): boolean {
    for (const consume of consumes) {
        if ('multipart/form-data' === consume.contentType) {
            return true;
        }
    }
    return false;
}

export interface Consume {
    contentType: string;
}

export interface RequestContext {
    fetch: FetchAPI;
    url: string;
    init: RequestInit;
}

export interface ResponseContext {
    fetch: FetchAPI;
    url: string;
    init: RequestInit;
    response: Response;
}

export interface ErrorContext {
    fetch: FetchAPI;
    url: string;
    init: RequestInit;
    error: unknown;
    response?: Response;
}

export interface Middleware {
    pre?(context: RequestContext): Promise<FetchParams | void>;
    post?(context: ResponseContext): Promise<Response | void>;
    onError?(context: ErrorContext): Promise<Response | void>;
}

export interface ApiResponse<T> {
    raw: Response;
    value(): Promise<T>;
}

export interface ResponseTransformer<T> {
    (json: any): T;
}

export class JSONApiResponse<T> {
    constructor(public raw: Response, private transformer: ResponseTransformer<T> = (jsonValue: any) => jsonValue) {}

    async value(): Promise<T> {
        return this.transformer(await this.raw.json());
    }
}

export class VoidApiResponse {
    constructor(public raw: Response) {}

    async value(): Promise<void> {
        return undefined;
    }
}

export class BlobApiResponse {
    constructor(public raw: Response) {}

    async value(): Promise<Blob> {
        return await this.raw.blob();
    };
}

export class TextApiResponse {
    constructor(public raw: Response) {}

    async value(): Promise<string> {
        return await this.raw.text();
    };
}
